export default __webpack_public_path__ + "static/media/jamband.ada57c3f.png";